import { ConfigProviderProps } from 'antd';
import frFR from 'antd/locale/fr_FR';
import 'theme/overrides.scss';
import theme from 'theme/theme.json'; // à modifier dans https://ant.design/theme-editor

import dayjs from 'dayjs';

import 'dayjs/locale/fr';

dayjs.locale('fr');

const appTheme: ConfigProviderProps = {
  locale: frFR,
  theme,
};

export default appTheme;
